enum OilMonitoringActionTypeEnum {
  none = 'action_none',
  change = 'action_oil_change',
  filtration = 'action_oil_filtration',
}

export default OilMonitoringActionTypeEnum;
